// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__xjTeo","icon":"Alert_icon__ZoCes","content":"Alert_content__+av6G"};